<template>
  <div class="download">
    <headernav defaultActive="/download"/>
    <banner :img="backimg" title="成功案例" />
    <div class="anlibox">
     <img :src="item.more.thumbnail" mode="widthFix" alt="" v-for="item in list" :key="item.id">
    </div>
     <botsolid/>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import Botsolid from "../components/botsolid";
import Headernav from "../components/headernav";
export default {
  components: {
    Banner,
    Botsolid,
    Headernav
  },
  data(){
    return{
    list:[],
    backimg:''
    }
  },
  mounted(){
  this.getlist()
   this.getbackimg()
  },
  methods:{
    getbackimg(){
     this.$http.get("/api/portal/julihe/category_detail?id=15",).then(response => {
   window.console.log(response)
   this.backimg = response.data.data.more.thumbnail
      })
    },
getlist(){
     this.$http.get("/api/portal/julihe/category_posts?limit=100&category_id=15",).then(response => {
          this.list = response.data.data.list
        window.console.log(response)
      })
}
  }
};
</script>

<style lang="scss" scoped>
.anlibox{
   animation:leftbox 1s 1 linear;
}
 @keyframes leftbox{
           0%{
             margin-left:20%;
             opacity: 0;
           }
           100%{
            //  margin-bottom: 10%;
             opacity: 1;
           }
        }
.anlibox{
  width:80%;
  margin-left:10%;
  padding-top:40px;
  padding-bottom: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  img{
    vertical-align: middle;
    width:19%;
    transition: all 0.8s linear;
    margin-bottom:20px;
  }
  img:hover{
transform: scale(1.3);
transition: all 0.8s linear;
  }
}
</style>